import { render, staticRenderFns } from "./AllChats.vue?vue&type=template&id=61a97b76&"
import script from "./AllChats.vue?vue&type=script&lang=ts&"
export * from "./AllChats.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports